import axios from 'axios';
import axiosUrl from './axios.service';
import store from '../store/index';
const API_URL = axiosUrl.getAxiosUrl();

class FiltersService {
  getDefaultFilters() {
    return axios
      .get(API_URL + `/FomoRecordFilters/Filters`)
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setOrganisationsFilters',
          response.data.organisationFilters
        );
        store.commit('fomoStatisticsSearch/createOrganisationsOptions');
        store.commit('fomoStatisticsSearch/createOrganisationsOptionsString');
        store.commit(
          'fomoStatisticsSearch/setSubjectsFilters',
          response.data.applicationSubjectFilters
        );
        store.commit('fomoStatisticsSearch/createSubjectsOptions');
        store.commit('fomoStatisticsSearch/createSubjectsOptionsString');
        /*      store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString'); */
        store.commit(
          'fomoStatisticsSearch/setYearsFilters',
          response.data.yearFilters
        );
        store.commit('fomoStatisticsSearch/createYearsOptions');
        store.commit('fomoStatisticsSearch/createYearsOptionsString');
      })
  }
  /* 
  getCustomersFilter(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/Customers`, {
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString');
      })
  }
 */

  getCustomersWithExcludeFilter(filterText, customerId) {
    return axios
      .get(API_URL + `/FomoRecordFilters/CustomersWithExclude`, {
        params: {
          filter: filterText,
          mainCustomerId: customerId != null ? customerId : '',
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createCustomersOptions');
        store.commit('fomoStatisticsSearch/createCustomersOptionsString');
      })
  }

  getCustomersFilter(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/Customers`, {
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setMainCustomersFilters',
          response.data.customerFilters
        );
        store.commit('fomoStatisticsSearch/createMainCustomersOptions');
        store.commit('fomoStatisticsSearch/createMainCustomersOptionsString');
      })
  }
  getKvkNumbersFilter(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/CustomersKvkNumbers`, {
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
      store.commit(
        'fomoStatisticsSearch/setKvkNumbers',
        response.data
      );
      store.commit('fomoStatisticsSearch/createKvkNumberOptions');
      })
  }
  getSbiCodesByCustomers(filterText) {
    return axios
      .get(API_URL + `/FomoRecordFilters/CustomersSbiCodes`, {
        params: {
          filter: filterText,
        },
      })
      .then((response) => {
      store.commit(
        'fomoStatisticsSearch/setSbiCodes',
        response.data
      );
      store.commit('fomoStatisticsSearch/createSbiCodeOptions');
      })
  }
  
  getDefaultFileFilters(fileId) {
    return axios
      .get(API_URL + `/FomoRecordFilters/FileFilters`, {
        params: {
          fileId: fileId,
        },
      })
      .then((response) => {
        store.commit(
          'fomoStatisticsSearch/setOrganisationsFilters',
          response.data.organisationFilters
        );
        store.commit('fomoStatisticsSearch/createOrganisationsOptions');
        store.commit('fomoStatisticsSearch/createOrganisationsOptionsString');
        store.commit(
          'fomoStatisticsSearch/setSubjectsFilters',
          response.data.applicationSubjectFilters
        );
        store.commit('fomoStatisticsSearch/createSubjectsOptions');
        store.commit('fomoStatisticsSearch/createSubjectsOptionsString');
        store.commit(
          'fomoRecordsSearch/setCustomerFilters',
          response.data.customerFilters
        );
      })
  }
}

export default new FiltersService();
